<div class="navigation-desktop">
  <ul class="navigation-desktop__list">
    @for (
      navigationItem of navigationItems();
      track navigationItem.name;
      let index = $index
    ) {
      @let id = 'navigation-desktop-dropdown-' + index;
      @if (navigationItem.children?.length) {
        <li
          class="navigation-desktop__dropdown"
          ngbDropdown
          [wlAutomationId]="id"
          #navigationDropdown
        >
          <!-- NOTE: <wl-nav-link> does not work in combination with ngbDropdownToggle :( so some styling was duplicated -->
          <button
            class="navigation-desktop__dropdown-link"
            [id]="id + '-trigger'"
            [wlAutomationId]="id + '-trigger'"
            ngbDropdownToggle
            wlTrackLink
            [trackLinkInfo]="{
              type: 'button',
              field: 'navigation-dropdown-link',
              eventType: 'button-click',
            }"
          >
            {{ navigationItem.name }}
            <fa-icon
              class="navigation-desktop__dropdown-icon"
              icon="chevron-down"
              [fixedWidth]="true"
            />
          </button>
          <div
            ngbDropdownMenu
            [attr.aria-labelledby]="id + '-trigger'"
            class="navigation-desktop__dropdown-menu"
          >
            @for (child of navigationItem.children; track child.name) {
              <!-- NOTE: We don't use the [ngbDropdownItem] directive here, this means we are missing the "arrow
                         keyboard navigation". When adding this directive we can't use <wl-nav-link> because
                         it will make that element focusable :( decided to go with <wl-nav-link> over [ngbDropdownItem]
                         since arrow navigation is not part of the WCAG spec -->
              <wl-nav-link
                class="navigation-desktop__dropdown-menu-item"
                [linkUrl]="child.path"
                [linkTitle]="child.name"
                (clicked)="navigationEffects()"
              />
            }
          </div>
        </li>
      } @else {
        <li class="navigation-desktop__item">
          <wl-nav-link
            class="navigation-desktop__link"
            [linkUrl]="navigationItem.path"
            [linkTitle]="navigationItem.name"
            (clicked)="navigationEffects()"
          />
        </li>
      }
    }
  </ul>
</div>
